import "utils/polyfills";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./shared/style/reset.css";
import "./shared/style/typography.css";
import registerServiceWorker from "./registerServiceWorker";
import online from "./online.js";
import initReactFastClick from "react-fastclick";
import Raven from "raven-js";

const startApp = () => {
  initReactFastClick();
  ReactDOM.render(<App />, document.getElementById("root"));
  registerServiceWorker();
  online();
  window.scrollTo(0, 1);
};

if (process.env.REACT_APP_ENV !== "DEVELOPMENT") {
  Raven.config(process.env.REACT_APP_SENTRY_URL, {
    release: process.env.REACT_APP_ENV,
    captureUnhandledRejections: true
  }).install();

  Raven.context(function() {
    startApp();
  });
} else {
  startApp();
}



// WEBPACK FOOTER //
// ./src/index.js